import { timeRangeZodSchema } from "@@/shared/date-time/time-range";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { generateWordSlug } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { orderItemIdZodSchema } from "../../../order-items/order-item-id";
import { signatureFactory } from "../../signature-factory";
import {
    _orderEventBaseFactory,
    _orderEventBaseZodObject,
} from "../_order-base.event";

const orderItemBookableTimeUpdatedEventZodObject =
    _orderEventBaseZodObject.merge(
        z.object({
            type: z.literal("ORDER_ITEM_BOOKABLE_TIME_UPDATED"),
            changedBy: userIdZodSchema,
            orderItemId: orderItemIdZodSchema,
            from: timeRangeZodSchema,
            to: timeRangeZodSchema,
        }),
    );
type OrderItemBookableTimeUpdatedEvent = z.infer<
    typeof orderItemBookableTimeUpdatedEventZodObject
>;
const orderItemBookableTimeUpdatedEventZodSchema =
    orderItemBookableTimeUpdatedEventZodObject as z.ZodSchema<OrderItemBookableTimeUpdatedEvent>;

type FactoryParams = Except<
    OrderItemBookableTimeUpdatedEvent,
    "_id" | "_createdAt" | "_type" | "type"
>;

type Params = Except<FactoryParams, "signature">;

const orderItemBookableTimeUpdatedEventFactory = (
    params: Params,
): OrderItemBookableTimeUpdatedEvent => ({
    ..._orderEventBaseFactory({
        orderId: params.orderId,
        orderGroupId: params.orderGroupId,
        _version: params._version,
        providerId: params.providerId,
        providerSlug: params.providerSlug,
        signature: signatureFactory(
            params.orderId,
            "ORDER_ITEM_BOOKABLE_TIME_UPDATED",
            [params.orderItemId, generateWordSlug()],
        ),
    }),
    ...params,
    type: "ORDER_ITEM_BOOKABLE_TIME_UPDATED",
});

export {
    orderItemBookableTimeUpdatedEventFactory,
    orderItemBookableTimeUpdatedEventZodObject,
    orderItemBookableTimeUpdatedEventZodSchema,
};
export type { OrderItemBookableTimeUpdatedEvent };
